import { Box, Chip, LinearProgress, Typography } from '@mui/material'

import type { FileUploadStatus } from '../types/article.types'
import { getFileSignature, getReadableFileSize } from '../utils/fileUtils'

type ArticleUploadStatusProps = {
  file: File
  uploadStatuses: Record<string, FileUploadStatus>
}

export function ArticleUploadStatus({ file, uploadStatuses }: ArticleUploadStatusProps) {
  const status = uploadStatuses[getFileSignature(file)]

  if (!status) {
    return (
      <Typography variant="caption" color="text.secondary">
        {getReadableFileSize(file.size)}
      </Typography>
    )
  }

  const sizeText = status.uploadSize && status.uploadSize !== status.originalSize
    ? `${getReadableFileSize(status.originalSize)} to ${getReadableFileSize(status.uploadSize)}`
    : getReadableFileSize(status.originalSize)

  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Box display="flex" gap={0.75} alignItems="center" flexWrap="wrap">
        <Chip
          size="small"
          label={
            status.phase === 'compressing'
              ? 'Compressing'
              : status.phase === 'uploading'
                ? `Uploading ${status.progress}%`
                : status.phase === 'complete'
                  ? 'Uploaded'
                  : 'Upload failed'
          }
          color={status.phase === 'error' ? 'error' : status.phase === 'complete' ? 'success' : 'primary'}
          variant="outlined"
        />
        <Typography variant="caption" color="text.secondary">
          {status.message ? `${status.message} - ${sizeText}` : sizeText}
        </Typography>
      </Box>
      {status.phase === 'uploading' && (
        <LinearProgress variant="determinate" value={status.progress} />
      )}
    </Box>
  )
}
